module.exports = __webpack_public_path__ + "img/ServiceAccountIMG.6ad8461d.jpg";